import { fetchCategory } from '@/api/programs';

// import hero from './hero';
// import programs from './programs';

export default {
  namespaced: true,
  state() {
    return {
      id: undefined,
      slug: undefined,
      name: undefined,
      description: undefined,
    };
  },
  mutations: {
    setId(state, id) {
      state.id = id;
    },
    setSlug(state, slug) {
      state.slug = slug;
    },
    setName(state, name) {
      state.name = name;
    },
    setDescription(state, description) {
      state.description = description;
    },
  },
  actions: {
    async fetch({
      rootState: {
        route: {
          params: {
            category: slug,
          },
        },
      },
      commit,
      // dispatch,
    }) {
      const {
        id,
        name,
        description,
        // acf: { hero: heroData },
      } = (await fetchCategory(slug));

      commit('setId', id);
      commit('setSlug', slug);
      commit('setName', name);
      commit('setDescription', description);

      // dispatch('hero/fetch', heroData);
      // dispatch('programs/fetch', );
      // commit('setPrograms', await fetchCategoryPrograms());
    },
  },
  // modules: {
  //   // hero,
  //   // programs,
  // },
};
